/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cart-and-order-table[_ngcontent-%COMP%]{width:100%}.cart-and-order-table[_ngcontent-%COMP%]   .row-header[_ngcontent-%COMP%]{font-size:12px;letter-spacing:.1px;color:#ccc;text-transform:uppercase}.cart-and-order-table[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]   .col-price[_ngcontent-%COMP%], .cart-and-order-table[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]   .col-quantity[_ngcontent-%COMP%]{padding-right:45px}"];
export { styles as styles };
